module.exports = __webpack_public_path__ + "img/panelView_defaultBg_strong_Bg_4_3.8f341fe0.png";